// @ts-strict-ignore
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { setGMapsError } from 'store/main/ducks/gMapsError';
import { isBrowser } from 'utils/browser';

type Props = PropsFromRedux;

class SetGMapsError extends React.PureComponent<Props> {
  componentDidMount() {
    if (isBrowser()) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pageData: { landingSearch?: Object; }; } |... Remove this comment to see the full error message
      window.Idealist = window.Idealist || {};

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
      window.Idealist.setGMapsError = (errorType) => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.setGMapsError(errorType);
      };
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gmapsErrors' does not exist on type '{ p... Remove this comment to see the full error message
    if (Array.isArray(window.Idealist.gmapsErrors)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'gmapsErrors' does not exist on type '{ p... Remove this comment to see the full error message
      window.Idealist.gmapsErrors.forEach((errorType) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
        window.Idealist.setGMapsError(errorType);
      });
    }
  }

  render() {
    return null;
  }
}

const connector = connect(null, { setGMapsError });

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default connector(SetGMapsError);
